import { clientInstance } from '../../utils/http-client'
import { baseAPICall } from '../baseAPICall'
import type {
  AdminCaptureForm,
  AdminCaptureFormInput,
  Capture,
  CaptureForm,
  CaptureSubmitPayload,
} from '../../models/captureForms'

export function listCaptureForms() {
  return baseAPICall<CaptureForm[]>(() =>
    clientInstance.get('capture-forms/forms/')
  )
}

export function getCaptureForm(id: number) {
  return baseAPICall<CaptureForm>(() =>
    clientInstance.get(`capture-forms/forms/${id}/`)
  )
}

export function submitCapture(payload: CaptureSubmitPayload) {
  return baseAPICall<Capture>(() =>
    clientInstance.post('capture-forms/submit/', payload)
  )
}

export function getCapture(id: number) {
  return baseAPICall<Capture>(() =>
    clientInstance.get(`capture-forms/captures/${id}/`)
  )
}

export function updateCapture(id: number, values: Record<string, unknown>) {
  return baseAPICall<Capture>(() =>
    clientInstance.patch(`capture-forms/captures/${id}/`, { values })
  )
}

export function deleteCapture(id: number) {
  return baseAPICall<void>(() =>
    clientInstance.delete(`capture-forms/captures/${id}/`)
  )
}

export function listAdminCaptureForms() {
  return baseAPICall<AdminCaptureForm[]>(() =>
    clientInstance.get('capture-forms/admin/forms/')
  )
}

export function createAdminCaptureForm(data: AdminCaptureFormInput) {
  return baseAPICall<AdminCaptureForm>(() =>
    clientInstance.post('capture-forms/admin/forms/', data)
  )
}

export function updateAdminCaptureForm(
  id: number,
  data: AdminCaptureFormInput
) {
  return baseAPICall<AdminCaptureForm>(() =>
    clientInstance.patch(`capture-forms/admin/forms/${id}/`, data)
  )
}

export function deleteAdminCaptureForm(id: number) {
  return baseAPICall<void>(() =>
    clientInstance.delete(`capture-forms/admin/forms/${id}/`)
  )
}
